import { render } from "./YoubeDettaglioOrdine.vue?vue&type=template&id=58f93007&scoped=true"
import script from "./YoubeDettaglioOrdine.vue?vue&type=script&lang=js"
export * from "./YoubeDettaglioOrdine.vue?vue&type=script&lang=js"

import "./YoubeDettaglioOrdine.vue?vue&type=style&index=0&id=58f93007&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f93007"]])

export default __exports__